export default "__VITE_ASSET__5842d697__"